import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedIrrigationRoute from "./components/ProtectedIrrigationRoute";

import Topbar from "./components/Topbar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Spinner from "./components/Spinner";
import BackToTop from "./components/BackToTop";

import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import ContactPage from "./pages/Contact";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import SWIP from "./pages/SWIP";
import ContentList from "./pages/ContentList";
import ContentDetails from "./pages/ContentDetails";
import IrrigationHistory from "./pages/IrrigationHistory";
import TodayIrrigation from "./pages/TodayIrrigation";
import SearchResults from "./pages/SearchResults";
import ProjectsPage from "./pages/ProjectsPage";
import TeamList from "./pages/TeamList";
import TeamDetails from "./pages/TeamDetails";
import AdminContentList from "./pages/ContentListAdmin";
import AddContent from "./pages/AddContent";
import EditContent from "./pages/EditContent";
import AdminTeamList from "./pages/TeamListAdmin";
import AddTeam from "./pages/AddTeam";
import EditTeam from "./pages/EditTeam";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Router>
      <Topbar />
      <Navbar />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/blogs" element={<ContentList type="blog" />} />
        <Route path="/workshops" element={<ContentList type="workshop" />} />
        <Route path="/training" element={<ContentList type="training" />} />
        <Route path="/publications" element={<ContentList type="publication" />} />
        <Route path="/reports" element={<ContentList type="report" />} />
        <Route path="/livinglab" element={<ContentList type="livinglab" />} />
        <Route path="/events" element={<ContentList type="event" />} />
        <Route path="/content/:publicId" element={<ContentDetails />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/team" element={<TeamList />} />
        <Route path="/team/:id" element={<TeamDetails />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        <Route path="/swip" element={<ProtectedRoute><SWIP /></ProtectedRoute>} />
        <Route path="/irrigation" element={<ProtectedIrrigationRoute><IrrigationHistory /></ProtectedIrrigationRoute>} />
        <Route path="/today-irrigation" element={<ProtectedIrrigationRoute><TodayIrrigation /></ProtectedIrrigationRoute>} />
        
        {/* Admin protected routes */}
        <Route path="/admin/contents" element={<ProtectedRoute role="admin"><AdminContentList /></ProtectedRoute>} />
        <Route path="/admin/addContent" element={<ProtectedRoute role="admin"><AddContent /></ProtectedRoute>} />
        <Route path="/admin/contents/edit/:id" element={<ProtectedRoute role="admin"><EditContent /></ProtectedRoute>} />
        <Route path="/admin/team" element={<ProtectedRoute role="admin"><AdminTeamList /></ProtectedRoute>} />
        <Route path="/admin/team/add" element={<ProtectedRoute role="admin"><AddTeam /></ProtectedRoute>} />
        <Route path="/admin/team/edit/:id" element={<ProtectedRoute role="admin"><EditTeam /></ProtectedRoute>} />
      </Routes>
      <BackToTop />
      <Footer />
    </Router>
  );
}

export default App;
